module.exports = __webpack_public_path__ + "static/02 - Carnegie_Mellon_University.svg-4e4972d817f2f43c593132cc7f8bcb64.png";